export const createSettingsTeamRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
